import { AxiosResponse } from "axios";
import { request } from "@utils";
import { PaginatedCustomers } from "@types";

export const getAllCustomers = (
  page: number,
): Promise<AxiosResponse<PaginatedCustomers>> => {
  const req = request();
  return req.get(`/api/v1/customers/paginated?page=${page}&limit=10`);
};
